import React, { useContext } from "react";
import { GlobalDataContext } from "../context/context";
import TransparentHeader from "../components/global/TransparentHeader";
import BaseLayout from "../components/global/BaseLayout";
import FormAppoitment from "../components/block/FormAppoiment"

function Appointment() {
  const { rpdata } = useContext(GlobalDataContext);
  return (
    <BaseLayout PageName="Appointment">
      <div className="md:max-w-full w-full">
        <TransparentHeader
          headertitle="Appointment"
          Subheader="Appointment"
          bgimg={`${rpdata?.gallery?.[9]}`}
        />
        <FormAppoitment image1={rpdata?.gallery?.[16]}/>

      </div>
    </BaseLayout>
  );
}

export default Appointment;
